<script>
  import { intcomma } from 'journalize';
  import parties from '../utils/parties';

  /** @type {string} */
  export let name;
  /** @type {string} */
  export let color;
  /** @type {string} */
  export let party;
  /** @type {number} */
  export let votes;
  /** @type {string} */
  export let votePercent;
  /** @type {boolean} */
  export let isWinner = false;
</script>

<tr class="candidate contest__candidate-row">
  <th scope="row" class="candidate__cell candidate__cell-checkmark text-regular">
    {#if isWinner}
    <span class="ml-n3" aria-label="checkmark, winner">✓</span>
    {/if}
  </th>
  <th scope="row" class="candidate__cell candidate__cell-name text-regular">
    <span class="circle-pill" style="background-color: {color};" aria-hidden="true"/>
    <span class="text-bold">{name}</span> <span class="party_abbr">({parties[party] ? parties[party].abbr : party.toUpperCase()})</span>
  </th>
  <td class="candidate__cell candidate__cell-votes text-left color-grey">
    {intcomma(votes)}
  </td>
  <td class="candidate__cell candidate__cell-pct text-right">{votePercent}</td
    >
</tr>